module.exports = __webpack_public_path__ + "img/wz-8-5-4.61862fd0.jpg";